import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_3 = { class: "row g-0 w-100" }
const _hoisted_4 = { class: "col-sm-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_5 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "col-lg-6 col-md-6 d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "d-block",
  style: {"margin-left":"auto"}
}, null, -1)
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = {
  class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "fw-semobold text-gray-600" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "odd"
}
const _hoisted_19 = {
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_20 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.layout?.enableItemsPerPageDropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("label", null, [
                  _createElementVNode("select", {
                    name: "kt_customers_table_length",
                    class: "form-select form-select-sm form-select-solid",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                  }, _hoisted_10, 32)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          (_ctx.layout?.searching)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Search here..."
              }, null, 512)), [
                [_vModelText, _ctx.search]
              ])
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "header-custom-filter")
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", {
          class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"]),
          id: "kt_customers_table",
          role: "grid"
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (!cell.hidden)
                    ? (_openBlock(), _createElementBlock("th", {
                        key: 0,
                        onClick: ($event: any) => (
                    _ctx.sort(
                      cell.sortingField ? cell.sortingField : cell.key,
                      cell.sortable
                    )
                  ),
                        class: _normalizeClass([
                    cell.name && 'min-w-125px',
                    cell.sortable !== false && 'sorting',
                    _ctx.currentSort ===
                      `${
                        cell.sortingField ? cell.sortingField : cell.key
                      }desc` && 'sorting_desc',
                    _ctx.currentSort ===
                      `${
                        cell.sortingField ? cell.sortingField : cell.key
                      }asc` && 'sorting_asc',
                  ]),
                        tabindex: "0",
                        rowspan: "1",
                        colspan: "1",
                        style: _normalizeStyle([{"cursor":"pointer"}, { textAlign: cell?.align }])
                      }, _toDisplayString(cell.name), 15, _hoisted_15))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_16, [
            _renderSlot(_ctx.$slots, "custom-row"),
            (_ctx.getItems.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: i,
                    onClick: ($event: any) => (_ctx.$emit('click:row', item)),
                    class: _normalizeClass(["odd", _ctx.rowClass])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                        (!cell.hidden)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              style: _normalizeStyle({ textAlign: cell?.align })
                            }, [
                              _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                                _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                              ])
                            ], 4))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 10, _hoisted_17))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.emptyTableText), 1)
                ]))
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.layout?.info)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Showing " + _toDisplayString(_ctx.paginationInfo.start) + " to " + _toDisplayString(_ctx.paginationInfo.end) + " of " + _toDisplayString(_ctx.paginationInfo.total) + " entries", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.pagination.page,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.page) = $event)),
            onCurrentChange: _ctx.currentPageChange,
            "page-size": _ctx.pagination.rowsPerPage,
            layout: "prev, pager, next",
            total: _ctx.pagination.total,
            "hide-on-single-page": _ctx.layout?.hideOnSinglePage,
            background: ""
          }, null, 8, ["current-page", "onCurrentChange", "page-size", "total", "hide-on-single-page"])
        ])
      ])
    ])
  ]))
}